import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar.js';

/** AppShell — ports `.app` (sidebar + main grid) and `.main`. Responsive collapse. */
const Page = styled.div`
  width: 100%;
  min-height: 100vh;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 240px 1fr;
  background: #fff;
  overflow: hidden;
  min-height: 100vh;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
const Main = styled.main`
  padding: 28px 36px 36px;
  overflow-y: auto;
  height: 100vh;

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    padding: 20px 16px 24px;
  }
`;

/** Layout wrapper for all authed routes. Feature pages render via <Outlet/>. */
export function AppShell() {
  return (
    <Page>
      <Grid>
        <Sidebar />
        <Main>
          <Outlet />
        </Main>
      </Grid>
    </Page>
  );
}
